var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import ManagerLayout from '../ManagerLayout';
import BorderdContainer from '../BorderedContainer';
import List from '@shared/List';
import { SettingType } from '@common/api';
import { useSetting, useSettingUpdate } from '@data/hooks/settings';
import FSButton from '@components/FSButton';
import Tabs from '../Tabs';
import { useLanguage } from '@base/LanguageProvider';
import { useTagContext } from '@data/tag/tagContext';
import { Loading, LoadingWrap } from '../../../../styled/Basic';
function toVersionItem(versionTag) {
    return {
        id: versionTag.id,
        title: versionTag.name,
    };
}
function toMonthItem(monthTag) {
    return { id: monthTag.id, title: monthTag.name.replace('M', '') };
}
function toYearItem(yearTag) {
    return { title: yearTag.name.replace('Y', ''), id: yearTag.id };
}
function toMatrixItemByYearMap(versionItems, yearItems, monthItems) {
    var e_1, _a, e_2, _b, e_3, _c;
    var matrixItemsMap = new Map();
    try {
        for (var yearItems_1 = __values(yearItems), yearItems_1_1 = yearItems_1.next(); !yearItems_1_1.done; yearItems_1_1 = yearItems_1.next()) {
            var yearItem = yearItems_1_1.value;
            var rows = [];
            try {
                for (var versionItems_1 = (e_2 = void 0, __values(versionItems)), versionItems_1_1 = versionItems_1.next(); !versionItems_1_1.done; versionItems_1_1 = versionItems_1.next()) {
                    var versionItem = versionItems_1_1.value;
                    var row = [];
                    try {
                        for (var monthItems_1 = (e_3 = void 0, __values(monthItems)), monthItems_1_1 = monthItems_1.next(); !monthItems_1_1.done; monthItems_1_1 = monthItems_1.next()) {
                            var monthItem = monthItems_1_1.value;
                            row.push({
                                versionId: versionItem.id,
                                monthId: monthItem.id,
                                month: monthItem.title,
                            });
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (monthItems_1_1 && !monthItems_1_1.done && (_c = monthItems_1.return)) _c.call(monthItems_1);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    rows.push(row);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (versionItems_1_1 && !versionItems_1_1.done && (_b = versionItems_1.return)) _b.call(versionItems_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            matrixItemsMap.set(yearItem.id, rows);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (yearItems_1_1 && !yearItems_1_1.done && (_a = yearItems_1.return)) _a.call(yearItems_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return matrixItemsMap;
}
function VersionsTimePointsMatrix(_a) {
    var _b, _c, _d, _e;
    var tabs = _a.tabs, selected = _a.selected, onTabChange = _a.onTabChange, locksData = _a.locksData, setLocksData = _a.setLocksData, matrixItems = _a.matrixItems, lockSetting = _a.lockSetting, lockMonth = _a.lockMonth;
    var L = useLanguage().L;
    var selectedId = (_b = selected === null || selected === void 0 ? void 0 : selected.id) !== null && _b !== void 0 ? _b : 0;
    var yearLocks = (_c = locksData[selectedId]) !== null && _c !== void 0 ? _c : {};
    var updateSetting = useSettingUpdate().mutate;
    function renderTimePointItem(item) {
        var checks = item.map(function (i) {
            return (React.createElement("input", { key: i.versionId + i.month, type: "checkbox", style: { cursor: 'pointer', width: 15, height: 15 }, checked: i.monthId in yearLocks && yearLocks[i.monthId].includes(i.versionId), onChange: function (e) {
                    var checked = e.target.checked;
                    if (checked) {
                        setLocksData(function (curr) {
                            var _a;
                            var _b;
                            var copy = __assign({}, curr);
                            var yearsCopy = (_b = copy[selectedId]) !== null && _b !== void 0 ? _b : {};
                            i.monthId in yearsCopy
                                ? yearsCopy[i.monthId].push(i.versionId)
                                : (copy[selectedId] = __assign(__assign({}, copy[selectedId]), (_a = {}, _a[i.monthId] = [i.versionId], _a)));
                            return copy;
                        });
                        return;
                    }
                    setLocksData(function (curr) {
                        var _a, _b;
                        var copy = __assign({}, curr);
                        var yearsCopy = (_a = copy[selectedId]) !== null && _a !== void 0 ? _a : {};
                        ((_b = yearsCopy[i.monthId]) === null || _b === void 0 ? void 0 : _b.length) > 1
                            ? (yearsCopy[i.monthId] = yearsCopy[i.monthId].filter(function (id) { return id !== i.versionId; }))
                            : delete yearsCopy[i.monthId];
                        return copy;
                    });
                } }));
        });
        return (React.createElement("div", { key: item === null || item === void 0 ? void 0 : item[0].versionId, style: { display: 'flex', alignItems: 'center', justifyContent: 'space-evenly', height: 21 } }, checks));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Tabs, { tabNames: tabs, selected: (_d = selected === null || selected === void 0 ? void 0 : selected.title) !== null && _d !== void 0 ? _d : '', onTabChange: onTabChange }),
        React.createElement(BorderdContainer, null,
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-evenly',
                    height: 21,
                    marginTop: 10,
                    marginBottom: 10,
                } }, (_e = matrixItems === null || matrixItems === void 0 ? void 0 : matrixItems[0]) === null || _e === void 0 ? void 0 : _e.map(function (_a) {
                var monthId = _a.monthId, month = _a.month;
                return (React.createElement("span", { onClick: function () { return lockMonth(monthId); }, key: "matrix-items-".concat(monthId), style: {
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        width: 15,
                        height: 15,
                        fontSize: 15,
                    } }, month));
            })),
            React.createElement(List, { items: matrixItems, renderItem: renderTimePointItem, Footer: React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'end',
                        padding: 15,
                        position: 'sticky',
                        bottom: 0,
                        left: 0,
                        right: 0,
                    } },
                    React.createElement(FSButton, { title: L('Save'), onClick: function () {
                            lockSetting && updateSetting(__assign(__assign({}, lockSetting), { value: JSON.stringify(locksData) }));
                        } })) }))));
}
function VersionsColumn(_a) {
    var versionItems = _a.versionItems, lockYear = _a.lockYear;
    var L = useLanguage().L;
    function renderVersionItem(item, index) {
        return (React.createElement("div", { onClick: function () { return lockYear(item.id); }, key: item.id, style: {
                fontWeight: 'bold',
                fontSize: 15,
                cursor: 'pointer',
                textAlign: 'center',
                marginTop: index === 0 ? 41 : undefined,
            } }, item.title));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginBottom: 15, fontSize: 20 } }, L('Versions')),
        React.createElement(BorderdContainer, null,
            React.createElement(List, { items: versionItems, renderItem: renderVersionItem }))));
}
function LocksManagerInner(props) {
    var _a, _b, _c, _d;
    var L = useLanguage().L;
    var _e = __read(useState({}), 2), locksData = _e[0], setLocksData = _e[1];
    var yearItems = props.tagData.internalTagsMap.years.map(toYearItem);
    var versionItems = props.tagData.internalTagsMap.versions.map(toVersionItem);
    var monthItems = props.tagData.internalTagsMap.months.map(toMonthItem);
    var matrixItemsMap = toMatrixItemByYearMap(versionItems, yearItems, monthItems);
    var _f = __read(useState(yearItems === null || yearItems === void 0 ? void 0 : yearItems[0]), 2), year = _f[0], setYear = _f[1];
    function changeTabHandler(tab) {
        setYear(yearItems.find(function (y) { return y.title === tab; }));
    }
    useEffect(function () {
        var locks = JSON.parse(props.locksString);
        setLocksData(locks);
    }, [props.locksString]);
    function lockYear(versionId) {
        setLocksData(function (curr) {
            var e_4, _a, e_5, _b;
            var _c, _d, _e;
            var copy = __assign({}, curr);
            var yearId = (_c = year === null || year === void 0 ? void 0 : year.id) !== null && _c !== void 0 ? _c : 0;
            var yearLocks = (_d = copy[yearId]) !== null && _d !== void 0 ? _d : {};
            var shouldRemove = true;
            try {
                for (var monthItems_2 = __values(monthItems), monthItems_2_1 = monthItems_2.next(); !monthItems_2_1.done; monthItems_2_1 = monthItems_2.next()) {
                    var monthItem = monthItems_2_1.value;
                    if (!((_e = yearLocks === null || yearLocks === void 0 ? void 0 : yearLocks[monthItem.id]) === null || _e === void 0 ? void 0 : _e.includes(versionId))) {
                        shouldRemove = false;
                        break;
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (monthItems_2_1 && !monthItems_2_1.done && (_a = monthItems_2.return)) _a.call(monthItems_2);
                }
                finally { if (e_4) throw e_4.error; }
            }
            try {
                for (var monthItems_3 = __values(monthItems), monthItems_3_1 = monthItems_3.next(); !monthItems_3_1.done; monthItems_3_1 = monthItems_3.next()) {
                    var monthItem = monthItems_3_1.value;
                    if (shouldRemove) {
                        yearLocks[monthItem.id] =
                            yearLocks[monthItem.id] && yearLocks[monthItem.id].filter(function (vId) { return vId !== versionId; });
                        continue;
                    }
                    yearLocks[monthItem.id] = yearLocks[monthItem.id]
                        ? __spreadArray(__spreadArray([], __read(yearLocks[monthItem.id]), false), [versionId], false) : [versionId];
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (monthItems_3_1 && !monthItems_3_1.done && (_b = monthItems_3.return)) _b.call(monthItems_3);
                }
                finally { if (e_5) throw e_5.error; }
            }
            copy[yearId] = yearLocks;
            return copy;
        });
    }
    function lockMonth(monthId) {
        setLocksData(function (curr) {
            var _a, _b;
            var copy = __assign({}, curr);
            var yearId = (_a = year === null || year === void 0 ? void 0 : year.id) !== null && _a !== void 0 ? _a : 0;
            var yearLocks = (_b = copy[yearId]) !== null && _b !== void 0 ? _b : {};
            var versionIds = versionItems.map(function (_a) {
                var id = _a.id;
                return id;
            });
            var shoudRemove = Array.isArray(yearLocks[monthId]) &&
                yearLocks[monthId].length === versionIds.length &&
                versionIds.every(function (id) { return yearLocks[monthId].includes(id); });
            if (shoudRemove) {
                delete yearLocks[monthId];
                copy[yearId] = yearLocks;
                return copy;
            }
            yearLocks[monthId] = versionIds;
            copy[yearId] = yearLocks;
            return copy;
        });
    }
    var matrixItems = (_b = matrixItemsMap.get((_a = year === null || year === void 0 ? void 0 : year.id) !== null && _a !== void 0 ? _a : 0)) !== null && _b !== void 0 ? _b : [];
    var contentLeft = React.createElement(VersionsColumn, { versionItems: versionItems, lockYear: lockYear });
    var contentRight = (React.createElement(VersionsTimePointsMatrix, { tabs: (_d = (_c = yearItems === null || yearItems === void 0 ? void 0 : yearItems.map(function (y) { return y.title; })) === null || _c === void 0 ? void 0 : _c.sort(function (a, b) { return Number(a) - Number(b); })) !== null && _d !== void 0 ? _d : [], selected: year, locksData: locksData, lockSetting: props.lockSetting, onTabChange: changeTabHandler, setLocksData: setLocksData, lockMonth: lockMonth, matrixItems: matrixItems }));
    return React.createElement(ManagerLayout, { title: L('Locks'), contentLeft: contentLeft, contentRight: contentRight });
}
function LocksManager() {
    var _a = useTagContext(), tagData = _a.tagData, tagsLoading = _a.tagsLoading;
    var lockSetting = useSetting(SettingType.VersionYearLocks);
    var locksString = (lockSetting === null || lockSetting === void 0 ? void 0 : lockSetting.value) || '{}';
    if (tagsLoading || !lockSetting) {
        return (React.createElement(LoadingWrap, null,
            React.createElement(Loading, { "$size": 3 })));
    }
    return React.createElement(LocksManagerInner, { locksString: locksString, tagData: tagData, lockSetting: lockSetting });
}
export default LocksManager;
